import request from '@/utils/request'

export function getInfo() {
  return request({
    url: '/admin/admin_info',
    method: 'get'
  })
}

export function getRoles() {
  return request({
    url: '/admin/admin_menu',
    method: 'get'
  })
}

export function changePassword(data) {
  return request({
    url: '/profile/password',
    method: 'patch',
    data
  })
}

export function updateInfo(data) {
  return request({
    url: '/profile/update',
    method: 'put',
    data
  })
}

export function updateAvatar(data) {
  return request({
    url: '/profile/avatar',
    method: 'patch',
    data
  })
}
// 获取七牛云token
export function qiniuToken() {
  return request({
    url: '/qiniu/token',
    method: 'get'
  })
}
